module.exports = __webpack_public_path__ + "img/bg_space_tr8.22ed3b2d.png";